import Login from './components/Account/Login.vue'
import refresh from './components/refresh.vue'
import Home from './components/Home.vue'
import menuList from './components/Administrative/system/menu/list.vue'
import menuAdd from './components/Administrative/system/menu/add.vue'
import menuEdit from './components/Administrative/system/menu/edit.vue'
import systemConfig from './components/Administrative/system/config/add.vue'
import ruleList from './components/Administrative/system/rule/list.vue'
import ruleAdd from './components/Administrative/system/rule/add.vue'
import ruleEdit from './components/Administrative/system/rule/edit.vue'
import positionList from './components/Administrative/structures/position/list.vue'
import positionAdd from './components/Administrative/structures/position/add.vue'
import positionEdit from './components/Administrative/structures/position/edit.vue'
import structuresList from './components/Administrative/structures/structures/list.vue'
import structuresAdd from './components/Administrative/structures/structures/add.vue'
import structuresEdit from './components/Administrative/structures/structures/edit.vue'
import groupsList from './components/Administrative/structures/groups/list.vue'
import groupsAdd from './components/Administrative/structures/groups/add.vue'
import groupsEdit from './components/Administrative/structures/groups/edit.vue'
import usersList from './components/Administrative/personnel/users/list.vue'
import usersAdd from './components/Administrative/personnel/users/add.vue'
import usersEdit from './components/Administrative/personnel/users/edit.vue'
import modifypwd from './components/Administrative/personnel/users/modifypwd.vue'
import WebsiteConfig from './components/Administrative/website/website/add.vue'//官网配置管理
import actionlogList from './components/Administrative/actionlog/actionlog/list.vue'//操作日志
import loginlogList from './components/Administrative/actionlog/loginlog/list.vue'//登录日志
import WxIndexList from './components/Appistrative/index/list.vue'//小程序管理桌面
import WxClickList from './components/Appistrative/index/click_list.vue'//小程序点击统计
import companyList from './components/Appistrative/company/company/list.vue'//企业列表
import companyAdd from './components/Appistrative/company/company/add.vue'//企业添加
import companyEdit from './components/Appistrative/company/company/edit.vue'//企业编辑
import company_userList from './components/Appistrative/company/company/company_user.vue'//企业员工列表
import company_Index from './components/Appistrative/company/company/index.vue'//企业统计
import company_billList from './components/Appistrative/company/company/company_bill.vue'//企业报销列表
import company_bill_folderList from './components/Appistrative/company/company/company_bill_folder.vue'//企业发票列表
import userList from './components/Appistrative/company/user/list.vue'//员工列表
import userAdd from './components/Appistrative/company/user/add.vue'//员工添加
import userEdit from './components/Appistrative/company/user/edit.vue'//员工编辑
import user_companyList from './components/Appistrative/company/user/user_company.vue'//员工企业
import user_add_companyList from './components/Appistrative/company/user/add_company.vue'//员工添加企业
import user_billList from './components/Appistrative/company/user/user_bill.vue'//员工报销
import company_placeList from './components/Appistrative/company/company_place/list.vue'//企业审核列表
import billList from './components/Appistrative/company/bill/list.vue'//票据列表
import billAdd from './components/Appistrative/company/bill/add.vue'//票据添加
import billEdit from './components/Appistrative/company/bill/edit.vue'//票据编辑
import invoiceList from './components/Appistrative/company/invoice/list.vue'//发票列表
import invoiceAdd from './components/Appistrative/company/invoice/add.vue'//发票添加
import invoiceEdit from './components/Appistrative/company/invoice/edit.vue'//发票编辑
import costList from './components/Appistrative/company/cost/list.vue'//票据类型
import costAdd from './components/Appistrative/company/cost/add.vue'//类型添加
import costEdit from './components/Appistrative/company/cost/edit.vue'//类型编辑
import lunboList from './components/Appistrative/company/lunbo/list.vue'//轮播列表
import lunboAdd from './components/Appistrative/company/lunbo/add.vue'//轮播添加
import lunboEdit from './components/Appistrative/company/lunbo/edit.vue'//轮播编辑
import appConfig from './components/Appistrative/config/appconfig/add.vue'//app配置管理
import serviceList from './components/Appistrative/company/service/list.vue'//客服
import usedList from './components/Appistrative/company/used/list.vue'//常用语列表
import serviceConfig from './components/Appistrative/config/serviceconfig/add.vue'//客服配置管理
import robotList from './components/Appistrative/company/robot/list.vue'//智能客服列表
import robotAdd from './components/Appistrative/company/robot/add.vue'//智能客服添加
import robotEdit from './components/Appistrative/company/robot/edit.vue'//智能客服编辑
import powerList from './components/Appistrative/company/power/list.vue'//票据列表
import powerAdd from './components/Appistrative/company/power/add.vue'//票据添加
import powerEdit from './components/Appistrative/company/power/edit.vue'//票据编辑
import IndexList from './components/Index/index/list.vue'//后台首页
import developmentList from './components/Appistrative/company/development/list.vue'//开发列表
import developmentAdd from './components/Appistrative/company/development/add.vue'//开发添加
import developmentEdit from './components/Appistrative/company/development/edit.vue'//开发编辑

import f_IndexList from './components/Files/index/list.vue'//企业后台管理桌面
import f_ClickList from './components/Files/index/click_list.vue'//企业后台点击统计
import f_actionLog_List from './components/Files/actionlog/actionlog/list.vue'//操作日志
import f_loginLog_List from './components/Files/actionlog/loginlog/list.vue'//登录日志
import guideList from './components/Files/guide/list.vue'//票据类型
import guideAdd from './components/Files/guide/add.vue'//类型添加
import guideEdit from './components/Files/guide/edit.vue'//类型编辑

/**
 * meta参数解析
 * hideLeft: 是否隐藏左侧菜单，单页菜单为true
 * module: 菜单所属模块
 * menu: 所属菜单，用于判断三级菜单是否显示高亮，如菜单列表、添加菜单、编辑菜单都是'menu'，用户列表、添加用户、编辑用户都是'user'，如此类推
 */

const routes = [
  { path: '/', component: Login, name: 'Login' },
  {
    path: '/home',
    component: Home,
    children: [
      { path: '/refresh', component: refresh, name: 'refresh' }
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: 'menu/list', component: menuList, name: 'menuList', meta: { hideLeft: false, module: 'Administrative', menu: 'menu' }},
      { path: 'menu/add', component: menuAdd, name: 'menuAdd', meta: { hideLeft: false, module: 'Administrative', menu: 'menu' }},
      { path: 'menu/edit/:id', component: menuEdit, name: 'menuEdit', meta: { hideLeft: false, module: 'Administrative', menu: 'menu' }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: 'config/add', component: systemConfig, name: 'systemConfig', meta: { hideLeft: false, module: 'Administrative', menu: 'systemConfig' }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: 'rule/list', component: ruleList, name: 'ruleList', meta: { hideLeft: false, module: 'Administrative', menu: 'rule' }},
      { path: 'rule/add', component: ruleAdd, name: 'ruleAdd', meta: { hideLeft: false, module: 'Administrative', menu: 'rule' }},
      { path: 'rule/edit/:id', component: ruleEdit, name: 'ruleEdit', meta: { hideLeft: false, module: 'Administrative', menu: 'rule' }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: 'position/list', component: positionList, name: 'positionList', meta: { hideLeft: false, module: 'Administrative', menu: 'position' }},
      { path: 'position/add', component: positionAdd, name: 'positionAdd', meta: { hideLeft: false, module: 'Administrative', menu: 'position' }},
      { path: 'position/edit/:id', component: positionEdit, name: 'positionEdit', meta: { hideLeft: false, module: 'Administrative', menu: 'position' }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: 'structures/list', component: structuresList, name: 'structuresList', meta: { hideLeft: false, module: 'Administrative', menu: 'structures' }},
      { path: 'structures/add', component: structuresAdd, name: 'structuresAdd', meta: { hideLeft: false, module: 'Administrative', menu: 'structures' }},
      { path: 'structures/edit/:id', component: structuresEdit, name: 'structuresEdit', meta: { hideLeft: false, module: 'Administrative', menu: 'structures' }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: 'groups/list', component: groupsList, name: 'groupsList', meta: { hideLeft: false, module: 'Administrative', menu: 'groups' }},
      { path: 'groups/add', component: groupsAdd, name: 'groupsAdd', meta: { hideLeft: false, module: 'Administrative', menu: 'groups' }},
      { path: 'groups/edit/:id', component: groupsEdit, name: 'groupsEdit', meta: { hideLeft: false, module: 'Administrative', menu: 'groups' }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: 'users/list', component: usersList, name: 'usersList', meta: { hideLeft: false, module: 'Administrative', menu: 'users' }},
      { path: 'users/add', component: usersAdd, name: 'usersAdd', meta: { hideLeft: false, module: 'Administrative', menu: 'users' }},
      { path: 'users/edit/:id', component: usersEdit, name: 'usersEdit', meta: { hideLeft: false, module: 'Administrative', menu: 'users' }},
      { path: 'users/modifypwd', component: modifypwd, name: 'modifypwd', meta: { hideLeft: false, module: 'Administrative', menu: 'modifypwd' }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: 'website/add', component: WebsiteConfig, name: 'WebsiteConfig', meta: { hideLeft: false, module: 'Administrative', menu: 'website' }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: 'actionlog/list', component: actionlogList, name: 'actionlogList', meta: { hideLeft: false, module: 'Administrative', menu: 'actionlog' }},
      { path: 'loginlog/list', component: loginlogList, name: 'loginlogList', meta: { hideLeft: false, module: 'Administrative', menu: 'loginlog' }}
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'index/list', component: WxIndexList, name: 'WxIndexList', meta: { hideLeft: false, module: 'Appistrative', menu: 'index' }},
      { path: 'index/click_list', component: WxClickList, name: 'WxClickList', meta: { hideLeft: false, module: 'Appistrative', menu: 'click_index' }}
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'company/list', component: companyList, name: 'companyList', meta: { hideLeft: false, module: 'Appistrative', menu: 'company' }},
      { path: 'company/add', component: companyAdd, name: 'companyAdd', meta: { hideLeft: false, module: 'Appistrative', menu: 'company' }},
      { path: 'company/edit/:id', component: companyEdit, name: 'companyEdit', meta: { hideLeft: false, module: 'Appistrative', menu: 'company' }},
      { path: 'company/company_user/:id', component: company_userList, name: 'company_userList', meta: { hideLeft: false, module: 'Appistrative', menu: 'company' }},
      { path: 'company/index/:id', component: company_Index, name: 'company_Index', meta: { hideLeft: false, module: 'Appistrative', menu: 'company' }},
      { path: 'company/company_bill/:id', component: company_billList, name: 'company_billList', meta: { hideLeft: false, module: 'Appistrative', menu: 'company' }},
      { path: 'company/company_bill_folder/:id', component: company_bill_folderList, name: 'company_bill_folderList', meta: { hideLeft: false, module: 'Appistrative', menu: 'company' }}
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'user/list', component: userList, name: 'userList', meta: { hideLeft: false, module: 'Appistrative', menu: 'user' }},
      { path: 'user/add', component: userAdd, name: 'userAdd', meta: { hideLeft: false, module: 'Appistrative', menu: 'user' }},
      { path: 'user/edit/:id', component: userEdit, name: 'userEdit', meta: { hideLeft: false, module: 'Appistrative', menu: 'user' }},
      { path: 'user/user_company/:id', component: user_companyList, name: 'user_companyList', meta: { hideLeft: false, module: 'Appistrative', menu: 'user' }},
      { path: 'user/add_company/:id', component: user_add_companyList, name: 'user_add_companyList', meta: { hideLeft: false, module: 'Appistrative', menu: 'user' }},
      { path: 'user/user_bill/:id', component: user_billList, name: 'user_billList', meta: { hideLeft: false, module: 'Appistrative', menu: 'user' }}
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'company_place/list', component: company_placeList, name: 'company_placeList', meta: { hideLeft: false, module: 'Appistrative', menu: 'company_place' }},
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'bill/list', component: billList, name: 'billList', meta: { hideLeft: false, module: 'Appistrative', menu: 'bill' }},
      { path: 'bill/add', component: billAdd, name: 'billAdd', meta: { hideLeft: false, module: 'Appistrative', menu: 'bill' }},
      { path: 'bill/edit/:id', component: billEdit, name: 'billEdit', meta: { hideLeft: false, module: 'Appistrative', menu: 'bill' }},
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'invoice/list', component: invoiceList, name: 'invoiceList', meta: { hideLeft: false, module: 'Appistrative', menu: 'invoice' }},
      { path: 'invoice/add', component: invoiceAdd, name: 'invoiceAdd', meta: { hideLeft: false, module: 'Appistrative', menu: 'invoice' }},
      { path: 'invoice/edit/:id', component: invoiceEdit, name: 'invoiceEdit', meta: { hideLeft: false, module: 'Appistrative', menu: 'invoice' }},
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'cost/list', component: costList, name: 'costList', meta: { hideLeft: false, module: 'Appistrative', menu: 'cost' }},
      { path: 'cost/add', component: costAdd, name: 'costAdd', meta: { hideLeft: false, module: 'Appistrative', menu: 'cost' }},
      { path: 'cost/edit/:id', component: costEdit, name: 'costEdit', meta: { hideLeft: false, module: 'Appistrative', menu: 'cost' }},
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'development/list', component: developmentList, name: 'developmentList', meta: { hideLeft: false, module: 'Appistrative', menu: 'development' }},
      { path: 'development/add', component: developmentAdd, name: 'developmentAdd', meta: { hideLeft: false, module: 'Appistrative', menu: 'development' }},
      { path: 'development/edit/:id', component: developmentEdit, name: 'developmentEdit', meta: { hideLeft: false, module: 'Appistrative', menu: 'development' }},
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'lunbo/list', component: lunboList, name: 'lunboList', meta: { hideLeft: false, module: 'Appistrative', menu: 'lunbo' }},
      { path: 'lunbo/add', component: lunboAdd, name: 'lunboAdd', meta: { hideLeft: false, module: 'Appistrative', menu: 'lunbo' }},
      { path: 'lunbo/edit/:id', component: lunboEdit, name: 'lunboEdit', meta: { hideLeft: false, module: 'Appistrative', menu: 'lunbo' }},
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'appconfig/add', component: appConfig, name: 'appConfig', meta: { hideLeft: false, module: 'Appistrative', menu: 'appconfig' }}
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'service/list', component: serviceList, name: 'serviceList', meta: { hideLeft: false, module: 'Appistrative', menu: 'service' }},
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'used/list', component: usedList, name: 'usedList', meta: { hideLeft: false, module: 'Appistrative', menu: 'used' }},
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'serviceconfig/add', component: serviceConfig, name: 'serviceConfig', meta: { hideLeft: false, module: 'Appistrative', menu: 'serviceconfig' }}
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'robot/list', component: robotList, name: 'robotList', meta: { hideLeft: false, module: 'Appistrative', menu: 'robot' }},
      { path: 'robot/add', component: robotAdd, name: 'robotAdd', meta: { hideLeft: false, module: 'Appistrative', menu: 'robot' }},
      { path: 'robot/edit/:id', component: robotEdit, name: 'robotEdit', meta: { hideLeft: false, module: 'Appistrative', menu: 'robot' }},
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'power/list', component: powerList, name: 'powerList', meta: { hideLeft: false, module: 'Appistrative', menu: 'power' }},
      { path: 'power/add', component: powerAdd, name: 'powerAdd', meta: { hideLeft: false, module: 'Appistrative', menu: 'power' }},
      { path: 'power/edit/:id', component: powerEdit, name: 'powerEdit', meta: { hideLeft: false, module: 'Appistrative', menu: 'power' }},
    ]
  },
  {
    path: '/app',
    component: Home,
    children: [
      { path: 'actionlog/list', component: actionlogList, name: 'actionlogList', meta: { hideLeft: false, module: 'Appistrative', menu: 'actionlog' }},
      { path: 'loginlog/list', component: loginlogList, name: 'loginlogList', meta: { hideLeft: false, module: 'Appistrative', menu: 'loginlog' }}
    ]
  },
  {
    path: '/Index',
    component: Home,
    children: [
      { path: 'index/index', component: IndexList, name: 'IndexList', meta: { hideLeft: false, module: 'Index', menu: 'index' }}
    ]
  },
  {
    path: '/files',
    component: Home,
    children: [
      { path: 'index/list', component: f_IndexList, name: 'f_IndexList', meta: { hideLeft: false, module: 'Files', menu: 'index' }},
      { path: 'index/click_list', component: f_ClickList, name: 'f_ClickList', meta: { hideLeft: false, module: 'Files', menu: 'click_index' }}
    ]
  },
  {
    path: '/files',
    component: Home,
    children: [
      { path: 'actionlog/list', component: f_actionLog_List, name: 'f_loginLog_List', meta: { hideLeft: false, module: 'Files', menu: 'actionlog' }},
      { path: 'loginlog/list', component: f_loginLog_List, name: 'f_loginLog_List', meta: { hideLeft: false, module: 'Files', menu: 'loginlog' }}
    ]
  },
  {
    path: '/files',
    component: Home,
    children: [
      { path: 'guide/list', component: guideList, name: 'guideList', meta: { hideLeft: false, module: 'Files', menu: 'guide' }},
      { path: 'guide/add', component: guideAdd, name: 'guideAdd', meta: { hideLeft: false, module: 'Files', menu: 'guide' }},
      { path: 'guide/edit/:id', component: guideEdit, name: 'guideEdit', meta: { hideLeft: false, module: 'Files', menu: 'guide' }},
    ]
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/routes.js